package com.wintermar.inspection.core.ui.component.snackbar.util

actual fun getMaxWidthSnackBar() = 0.3f
